module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tc bg-white shadow-theme br-all",
    class: [
      _vm.disabled ? 'gray' : '',
      _vm.featured ? 'b-theme b-solid bw1' : '' ]
  }, [(_vm.showSavingsBanner && _vm.featureFlagMonthlyBillingActive) ? _c('div', {
    staticClass: "f4 bg-theme white tc pv3 savings-banner"
  }, [_c('strong', [_vm._v("SAVE $" + _vm._s(_vm.savings.toLocaleString()) + "!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa4"
  }, [(_vm.annual) ? _c('div', {
    staticClass: "mb4 fw3"
  }, [_c('div', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "f5 v-top"
  }, [_vm._v("$")]), _vm._v(" "), (_vm.planType === 'family') ? _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s((_vm.price / 12).toFixed(2)))]) : _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s((_vm.price / 12).toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "f5"
  }, [_vm._v(" / month ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt2 silver"
  }, [_c('span', {
    staticClass: "f5",
    domProps: {
      "textContent": _vm._s('Billed:')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "f6 v-top"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "f5"
  }, [_vm._v(_vm._s(_vm.price.toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "f6"
  }, [_vm._v(" / year ")])])]) : _vm._e(), _vm._v(" "), (!_vm.annual) ? _c('div', {
    staticClass: "mb4 fw3"
  }, [_c('div', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "f5 v-top"
  }, [_vm._v("$")]), _vm._v(" "), (_vm.planType === 'family') ? _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.price.toFixed(2)))]) : _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.price.toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "f5"
  }, [_vm._v(" / month ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt2 silver"
  }, [_c('span', {
    staticClass: "f5"
  }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
    staticClass: "f6 v-top"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "f5"
  }, [_vm._v(_vm._s((_vm.price * 12).toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "f6"
  }, [_vm._v(" / year ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3"
  }, [(_vm.current) ? _c('svg', {
    staticClass: "color-green dib v-sub",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 22s8-4 8-10V4l-8-2-8 2v8c0 6 8 10 8 10z"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "f4 fw4 ttc color-theme"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.planType === 'family') ? _c('div', {
    staticClass: "f6 fw4 fw3 mt2"
  }, [_vm._v("5% Multi-plan discount applied")]) : _vm._e()]), _vm._v(" "), (_vm.showFeatures) ? _c('div', {
    staticClass: "f6"
  }, [_c('hr', {
    staticClass: "b-theme bg-theme b-solid mv3 mw3 center"
  }), _vm._v(" "), (_vm.planType === 'AKKO') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("Add 1 Phone + 25 items*")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("Damage & Theft Protection")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'family') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("Add 1 Phone + 25 items per account")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("Damage & Theft Protection")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'PHONE') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v(_vm._s(_vm.phoneMake) + " - " + _vm._s(_vm.phoneModel))])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'family') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$29-99 Deductibles")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for phones")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'family') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$49 Student Deductible")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for all other items")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'family') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$99 Adult Deductible")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for all other items")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'AKKO') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$29-99 Deductibles")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for phones")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'AKKO') ? _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$" + _vm._s(this.deductible) + " Deductible")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for all other items")])]) : _vm._e(), _vm._v(" "), (_vm.planType === 'PHONE') ? _c('div', [_c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$" + _vm._s(this.phoneRepairDeductible) + " Deductible")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for repairs")])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 black"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("$" + _vm._s(this.phoneReplacementDeductible) + " Deductible")]), _vm._v(" "), _c('div', {
    staticClass: "silver lh-copy f6"
  }, [_vm._v("for replacement/theft")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 mw5 f4 center"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "disabled": _vm.current || _vm.disabled,
      "secondary": !_vm.featured && !_vm.current,
      "primary": _vm.featured && !_vm.current
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("Select")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt3 silver lh-copy f6"
  }, [(_vm.activationFee) ? _c('div', [_vm._v("+$5 one-time activation fee")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("Upgrade or downgrade anytime")]), _vm._v(" "), _c('div', [_vm._v("Prorated adjustments")])]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eba72e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoverageCardWm.vue
// module id = 566
// module chunks = 0